<template>
  <div class="table-part">
    <div v-if="tableTitle" class="table-part-header">
      <span class="table-part-title block-title">{{ tableTitle }}</span>
      <div><slot name="functionButtons"></slot></div>
    </div>
    <tablePart
      :isSelects="isSelects"
      :isMultiple="isMultiple"
      :columns="columns"
      :items="items"
      :viewName="viewName"
      :tableName="tableName"
      :changeIndex="currentIndex"
      :noInitialTableName="noInitialTableName"
      :initialWidth="initialWidth"
      :noColumnPropertySetting="noColumnPropertySetting"
      :useLocalColumns="useLocalColumns"
      :noHide="noHide"
      :hasDraggable="hasDraggable"
      :draggableHandle="draggableHandle"
      :isSortable="isSortable"
      :hasTotal="hasTotal"
      @onAuto="onAuto"
      @clickTdButton="clickTdButton"
      @onDragEnd="onDragEnd"
      @getSort="getSort"
      @currentIndexChanged="currentIndexChanged"
      @trClick="trClick"
      @trdbClicked="trdbClicked"
      @clickTd="clickTd"
    >
      <template #th-before>
        <slot name="th-before"></slot>
      </template>
      <template #th-after>
        <slot name="th-after">
          <th class="th-select" style="width: auto"></th>
          <th class="th-select" style="width: 50px"></th
        ></slot>
      </template>
      <template #td-before="props">
        <slot name="td-before" :item="props.item"></slot>
      </template>
      <template v-if="$slots.td" #td="props">
        <slot name="td" :column="props.column" :item="props.item"></slot>
      </template>
      <template #td-after="props">
        <slot name="td-after" :item="props.item">
          <td style="width: auto"></td>
          <td style="width: 50px"></td
        ></slot>
      </template>
      <template #inner-pagination-tool>
        <paginationTool
          v-if="showPage"
          :pagination="pagination"
          :hasPageSize="true"
          @pageChanged="pageChanged"
          @pageSizeChanged="pageSizeChanged"
        ></paginationTool>
      </template>
    </tablePart>
  </div>
</template>

<script>
import tablePart from "@/components/parts/tablePart.vue";
import paginationTool from "@/components/tools/PaginationTool.vue";

export default {
  data() {
    return {
      pagination: this.$func.defaultModel.getPage(),
      currentIndex: -1,
      directoryKindId: "",
      sortName: "",
      isDesc: 0,
    };
  },
  props: {
    getTrigger: Boolean,
    tableTitle: String,
    parentPage: Object,
    isSortable: Boolean,
    isSelects: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    columns: Array,
    hasPage: {
      type: Boolean,
      default: true,
    },
    items: Array,
    idProperty: String,
    nameProperty: String,
    searchTypes: Array,
    searchTypeName: String,
    viewName: String,
    tableName: String,
    noInitialTableName: {
      type: Boolean,
      default: false,
    },
    noInitialLoading: {
      type: Boolean,
      default: false,
    },
    initialWidth: String,
    changeIndex: {
      type: Number,
      default: -1,
    },
    allSelectId: String,
    noColumnPropertySetting: Boolean,
    useLocalColumns: Boolean,
    noHide: Boolean,
    hasDraggable: {
      type: Boolean,
      default: false,
    },
    draggableHandle: String,
    hasTotal: Boolean,
  },
  emits: [
    "onDragEnd",
    "getItems",
    "currentIndexChanged",
    "trClick",
    "trdbClicked",
    "onAuto",
    "clickTdButton",
    "clickTd",
  ],
  components: {
    tablePart,
    paginationTool,
  },
  computed: {
    showPage() {
      return this.pagination && this.hasPage;
    },
  },
  watch: {
    parentPage(value) {
      this.pagination = value;
    },
    getTrigger() {
      this.getItems();
    },
    changeIndex(value) {
      this.currentIndex = value;
    },
  },
  methods: {
    clickTd(item) {
      this.$emit("clickTd", item);
    },
    onAuto(column) {
      this.$emit("onAuto", column);
    },
    clickTdButton(item) {
      this.$emit("clickTdButton", item);
    },
    onDragEnd(items) {
      this.$emit("onDragEnd", items);
    },
    getSort(status) {
      this.sortName = status.sortName;
      this.isDesc = status.isDesc;
      this.getItems();
    },
    pageSizeChanged(pageSize) {
      this.pagination.PageSize = pageSize;
      this.pagination.CurrentPage = 1;
      this.getItems();
    },
    pageChanged(page) {
      this.pagination.CurrentPage = page;
      this.getItems();
    },
    getItems() {
      this.currentIndex = -1;
      if (this.directoryKinds) {
        this.$emit("getItems", {
          page: this.pagination.CurrentPage,
          pagesize: this.pagination.PageSize,
          sortName: this.sortName,
          isDesc: this.isDesc,
          directoryKindId: this.directoryKindId,
        });
        return;
      }
      let pageDTO;
      if (this.pagination) {
        pageDTO = {
          page: this.pagination.CurrentPage,
          pagesize: this.pagination.PageSize,
          searchType: this.searchType,
          searchText: this.searchText,
          sortName: this.sortName,
          isDesc: this.isDesc,
        };
      } else {
        pageDTO = {
          page: 1,
          pagesize: 500,
          isDesc: 0,
        };
      }
      this.$emit("getItems", pageDTO);
    },
    currentIndexChanged(index) {
      this.currentIndex = index;
      this.$emit("currentIndexChanged", this.currentIndex);
    },
    trClick(item) {
      this.$emit("trClick", item);
    },
    trdbClicked(item) {
      this.$emit("trdbClicked", item);
    },
  },
  mounted() {
    if (!this.noInitialLoading) this.getItems();
  },
};
</script>

<style lang="scss">
.table-part {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 20px;
  overflow-x: auto;
  @media screen and (min-width: 768px) {
    flex: 1;
    padding-bottom: 0;
  }
}
.table-part-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  // height: 50px;
  font-weight: 500;
}
.table-part-title {
  text-align: left;
  width: auto;
  margin-left: 2px;
  display: flex;
  align-items: center;
}
</style>
